import { type MouseEventHandler } from 'react';
import clsx from 'clsx';

import styles from './Icon.module.scss';

export interface IconProps {
    className?: string;
    component?: React.ComponentType;
    inheritColors?: boolean;
    name?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

export const Icon = ({
    className,
    component: Component,
    inheritColors,
    name,
    onClick,
    svgProps,
    ...rest
}: IconProps) => (
    <span
        className={clsx(
            'Icon',
            name && `${name}-icon`,
            styles['Icon'],
            onClick && styles['Icon--clickable'],
            inheritColors !== false && styles['Icon--inherit-colors'],
            className,
        )}
        onClick={onClick}
        style={
            svgProps?.width && svgProps.height
                ? {
                      width: svgProps?.width,
                      height: svgProps?.height,
                  }
                : undefined
        }
        {...rest}
    >
        {Component ? (
            <Component
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                preserveAspectRatio="xMidYMid meet"
                {...svgProps}
            />
        ) : null}
    </span>
);
